import { PaginationLink } from '@components/Pagination'

import TypeUtil from '@/utils/typeUtil'

interface IPaginationUtil {
  generate: (totalPage: number, currentPage?: number) => Array<PaginationLink>

  hasNextPage: (total?: number, page?: number, limit?: number) => boolean
}

const PaginationUtil: IPaginationUtil = {
  generate: (totalPage, currentPage = 1) => {
    const links: Array<PaginationLink> = []

    if (totalPage < 2) {
      return links
    }

    const maxShownPage = 5 // Odd
    if (totalPage > maxShownPage) {
      var startPage = currentPage - 2
      var endPage = currentPage + 2

      if (startPage < 3) {
        startPage = 1
      }
      if (endPage > totalPage - 2) {
        endPage = totalPage
      }

      for (let i = startPage; i <= endPage; i++) {
        links.push({
          active: i === currentPage,
          page: i,
          label: `${i}`,
        })
      }

      if (startPage !== 1) {
        links.unshift({
          active: false,
          page: 0,
          label: `...`,
        })
        links.unshift({
          active: false,
          page: 1,
          label: `1`,
        })
      }
      if (endPage !== totalPage) {
        links.push({
          active: false,
          page: 0,
          label: `...`,
        })
        links.push({
          active: false,
          page: totalPage,
          label: `${totalPage}`,
        })
      }
    } else {
      for (let i = 1; i <= totalPage; i++) {
        links.push({
          active: i === currentPage,
          page: i,
          label: `${i}`,
        })
      }
    }

    return [
      {
        label: 'Previous',
        page: currentPage - 1,
        active: totalPage > 2 && currentPage !== 1,
        isPrevious: true,
      },
      ...links,
      {
        label: 'Next',
        page: currentPage + 1,
        active: totalPage > 1 && currentPage !== totalPage,
        isNext: true,
      },
    ]
  },

  hasNextPage: (total, page, limit) => {
    return (
      TypeUtil.isDefined(total) &&
      TypeUtil.isDefined(page) &&
      TypeUtil.isDefined(limit) &&
      Math.ceil(total / limit) > page
    )
  },
}

export { PaginationUtil }
